import { asStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";

export interface BezonedMenuItem {
  label: string;
  component: React.ReactNode;
}

interface BezonedMenuTabsProps {
  items: BezonedMenuItem[];
  selectTab: (tab: string) => void;
  currentTab: string;
}

export const BezonedMenuTabs = ({
  items,
  selectTab,
  currentTab,
}: BezonedMenuTabsProps) => (
  <ul className="flex flex-row gap-6 lg:flex-col lg:gap-2">
    {items.map((item) => (
      <li key={item.label}>
        <button
          className={`hover:border-bzd-gray-500 rounded-sm border-b-4 pb-2 hover:cursor-pointer lg:border-b-0 lg:border-l-4 lg:pl-4 ${currentTab === item.label ? "border-bzd-gray-500" : "border-transparent"}`}
          onClick={asStableCallback(() => selectTab(item.label))}
          type="button"
        >
          {item.label}
        </button>
      </li>
    ))}
  </ul>
);
